function normalizeSocialUrl(value) {
  const candidate = String(value || "").trim();
  if (!candidate) return "";

  try {
    const parsed = new URL(candidate);
    return ["http:", "https:"].includes(parsed.protocol) ? parsed.toString() : "";
  } catch {
    return "";
  }
}

export const socialLinks = [
  {
    id: "telegram",
    url: normalizeSocialUrl(process.env.REACT_APP_TELEGRAM_URL),
    accent: "sky",
  },
  {
    id: "whatsapp",
    url: normalizeSocialUrl(process.env.REACT_APP_WHATSAPP_URL),
    accent: "emerald",
  },
  {
    id: "instagram",
    url: normalizeSocialUrl(process.env.REACT_APP_INSTAGRAM_URL),
    accent: "pink",
  },
];
